"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityType = exports.AssetType = exports.AssetExtension = exports.AssetContentType = void 0;
var AssetContentType;
(function (AssetContentType) {
    AssetContentType["AudioWav"] = "audio/wav";
    AssetContentType["FileCsv"] = "file/csv";
    AssetContentType["FileXlsx"] = "file/xlsx";
    AssetContentType["FileZip"] = "file/zip";
    AssetContentType["ImageHeic"] = "image/heic";
    AssetContentType["ImageJpeg"] = "image/jpeg";
    AssetContentType["ImageJpg"] = "image/jpg";
    AssetContentType["VideoMp4"] = "video/mp4";
    AssetContentType["ImagePng"] = "image/png";
    AssetContentType["ImageWebp"] = "image/webp";
    AssetContentType["Pdf"] = "application/pdf";
})(AssetContentType || (exports.AssetContentType = AssetContentType = {}));
var AssetExtension;
(function (AssetExtension) {
    AssetExtension["Csv"] = "csv";
    AssetExtension["Heic"] = "heic";
    AssetExtension["Jpeg"] = "jpeg";
    AssetExtension["Jpg"] = "jpg";
    AssetExtension["Mp4"] = "mp4";
    AssetExtension["Png"] = "png";
    AssetExtension["Webp"] = "webp";
    AssetExtension["Wav"] = "wav";
    AssetExtension["Xlsx"] = "xlsx";
    AssetExtension["Zip"] = "zip";
    AssetExtension["Pdf"] = "pdf";
})(AssetExtension || (exports.AssetExtension = AssetExtension = {}));
var AssetType;
(function (AssetType) {
    AssetType["Images"] = "images";
    AssetType["TemporaryFiles"] = "tmp/files";
    AssetType["TemporaryVideos"] = "tmp/videos";
    AssetType["Videos"] = "videos";
})(AssetType || (exports.AssetType = AssetType = {}));
var EntityType;
(function (EntityType) {
    EntityType["ImportItems"] = "import-items";
    EntityType["Items"] = "items";
    EntityType["Promotions"] = "promotions";
    EntityType["Stores"] = "stores";
    EntityType["Users"] = "users";
})(EntityType || (exports.EntityType = EntityType = {}));
//# sourceMappingURL=asset.js.map